var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"availability"},[(_vm.isOos)?_c('div',{staticClass:"availability__oos"},[_vm._v(" "+_vm._s(_vm.$labels.out_of_stock)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }